import { Button, Grid, Typography } from "@mui/material";
import { IUserItem } from "../types";
import dayjs from "dayjs";

interface IUserInformation {
  selectedUser: IUserItem;
}

interface IUserCard {
  label: string;
  value: string;
}

const UserCard = ({ label, value }: IUserCard) => {
  return (
    <Grid item md={3} lg={3} sm={6} xs={12}>
      <div className="bg-[#F5F5F5] p-4 rounded-md flex flex-col gap-2 w-auto">
        <Typography className="text-[#00000060] font-bold overflow-hidden text-ellipsis text-nowrap">
          {label}
        </Typography>
        <Typography className="font-bold overflow-hidden text-ellipsis text-nowrap">
          {value}
        </Typography>
      </div>
    </Grid>
  );
};

const UserInformation = ({
  selectedUser,
  isView,
}: IUserInformation & { isView?: boolean }) => {
  return (
    <Grid container spacing={2}>
      <UserCard label={"Name"} value={selectedUser?.name || "-"} />
      <UserCard label={"Email"} value={selectedUser?.email || "-"} />
      <UserCard label={"Phone Number"} value={selectedUser?.phoneNo || "-"} />
      {selectedUser?.stations?.length > 0 && (
        <UserCard
          label={"Stations"}
          value={selectedUser?.stations?.toString() || "-"}
        />
      )}

      <UserCard label={"Role"} value={selectedUser?.roleName || "-"} />
      {/* Only show date fields when viewing existing user */}
      {isView && (
        <>
          <UserCard
            label={"Created Date"}
            value={
              dayjs(selectedUser?.createdDate).format("DD/MM/YYYY hh:mm:ss") ||
              "-"
            }
          />
          <UserCard
            label={"Updated Date"}
            value={
              dayjs(selectedUser?.updatedDate).format("DD/MM/YYYY hh:mm:ss") ||
              "-"
            }
          />
        </>
      )}
    </Grid>
  );
};

const PreviewUser = ({
  selectedUser,
  onGoBack,
  onSaveAndNext,
  loading,
  isView = false,
}: any) => {
  return (
    <div className="h-full flex flex-col gap-6 mt-4">
      <div>
        <Typography className="font-bold mb-2" variant="h6">
          User Information
        </Typography>

        <UserInformation selectedUser={selectedUser} isView={isView} />
      </div>
      {!isView && (
        <Grid container>
          <Grid
            item
            md={12}
            lg={12}
            xs={12}
            className="flex gap-4 justify-end w-full mt-4"
          >
            <Button
              variant="outlined"
              type="button"
              onClick={onGoBack}
              disabled={loading}
            >
              Back
            </Button>
            <Button
              variant="contained"
              type="submit"
              onClick={() => onSaveAndNext({}, 2)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Submit"}
            </Button>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default PreviewUser;
